import styles from './PeriodSelector.module.css'

export function PeriodSelector({ options, value, onChange }) {
  return (
    <div className={styles.wrapper}>
      {options.map(opt => (
        <button
          key={opt.value}
          className={`${styles.btn} ${opt.value === value ? styles.active : ''}`}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  )
}
